import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classnames from "classnames";
import { componentStyles } from "./manage-option-component.scss";
class ManageOptionComponent extends PureComponent {
    onSelectItem() {
        const { optionText, onSelect } = this.props;
        onSelect(optionText);
    }
    render() {
        const { optionText, isSelected } = this.props;
        const backgroundColor = isSelected ? "rgba(163, 88, 223, 0.1)" : "none";
        return /*#__PURE__*/ _jsxs("div", {
            style: {
                background: backgroundColor
            },
            onClick: this.onSelectItem,
            className: `jsx-${componentStyles.__hash}` + " " + (classnames("manage-option-box", {
                selected: isSelected
            }) || ""),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "manage-option",
                    children: optionText
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.onSelectItem = this.onSelectItem.bind(this);
    }
}
export { ManageOptionComponent as default };
